export default __webpack_public_path__ + "static/media/blue_plus.1886870c.svg";